import React, { Component } from 'react'
import { Form, Row, Col, Alert } from 'react-bootstrap'
import { withTranslation } from 'react-i18next'
import { observable, makeObservable, action } from 'mobx'
import { observer } from 'mobx-react'
import styled from 'styled-components'
import { isNumeric } from '../../../utils/objectutils'
import trash from '../../../assets/icons/trash.svg'
import copy from '../../../assets/icons/copy.png'
import { Link } from 'react-router-dom'
import VariantView from '../../LocalReceipts/Form/VariantView'
import SerialkeyView from '../../LocalReceipts/Form/SerialkeyView'
import BatchkeyView from '../../LocalReceipts/Form/BatchkeyView'
import RFIDView from './RFIDView'
import { getIsoDate } from '../../../utils/getIsoDate'
import { colors } from '../../../styles/colors'
import PositionTabs from './PositionTabs.jsx'
import {
  LostIcon,
  RemovedIcon,
  StoredIcon,
} from '../../Complaints/PositionIcons.js'
import { StyledValidationMessage } from '../../LocalReceipts/Form/formHelper'
import CustomDropdownWithIcon from '../../Dropdowns/CustomDropdownWithIcon'
import { getMetaProperty } from '../../../utils/customerPrototypes'

const RIGHT_COLS = '80px 70px 110px 170px;'
const RIGHT_GAP = '14px'
const RIGHT_PADDING_X = 12

// const StyledWrapper = styled.div`
//   padding: 10px;
//   flex-grow: 1;
//   border-bottom: 1px solid ${colors.gray3};
// `
const StyledDisabled = styled.div`
  color: ${colors.gray3};
  font-weight: 600;
`
const StyledRemoveLink = styled(Link)`
  color: #ff0000;
  font-size: 0.9em;

  &:hover {
    color: #bf0000;
  }

  &:after {
    content: '';
    width: 1em;
    height: 1.1em;
    display: inline-block;
    margin-left: 0.25em;
    top: -2px;
    position: relative;
    vertical-align: middle;
    background: url(${trash}) center center no-repeat;
  }
`
const StyledCopyLink = styled(Link)`
  color: #000000;
  font-size: 0.9em;

  &:hover {
    color: #bf0000;
  }

  &:after {
    content: '';
    width: 1em;
    height: 1.1em;
    display: inline-block;
    margin-left: 0.25em;
    top: -2px;
    position: relative;
    vertical-align: middle;
    background: url(${copy}) center center no-repeat;
  }
`
const PositionCard = styled.div`
  background: #fff;
  border: 1px solid ${colors.gray3};
  border-radius: 10px;
  margin: 14px 0;
  overflow: hidden;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
`
const PositionHeaderStrip = styled.div`
  display: grid;
  grid-template-columns: 1fr 520px;
  align-items: center;

  padding: 14px 16px;
  background: #efeff1;
  border-bottom: 1px solid ${colors.gray3};
  column-gap: 16px;

  @media (max-width: 992px) {
    grid-template-columns: 1fr;
    row-gap: 8px;
  }
  @media (max-width: 576px) {
    grid-template-columns: 1fr 1.2fr;
  }
`

const HeaderLeftTitle = styled.div`
  font-size: 1.15rem;
`

const HeaderRightLabels = styled.div`
  padding: 0 ${RIGHT_PADDING_X}px;

  display: grid;
  grid-template-columns: ${RIGHT_COLS};
  gap: ${RIGHT_GAP};
  align-items: center;
  justify-items: center;

  @media (max-width: 992px) {
    padding: 0;
    grid-template-columns: 1fr 1fr;
    gap: 8px 14px;
  }
  @media (max-width: 992px) {
    display: none;
  }
`

const HeaderLabel = styled.div`
  font-weight: 700;
  // color: ${colors.gray2};
`

const PositionTopRow = styled.div`
  display: grid;
  grid-template-columns: 1fr auto;
  align-items: start;

  gap: 16px;
  padding: 16px;

  @media (max-width: 992px) {
    grid-template-columns: 1fr;
  }
`

const TopLeft = styled.div`
  min-width: 0;
  flex: 1;
`

const ArticleName = styled.div`
  font-size: 1.2rem;
  line-height: 1.2;
  word-break: break-word;
`

const ArticleNr = styled.div`
  margin-top: 6px;
  color: #2f2f2f; /* darker like screenshot */
  font-size: 1rem;
`
const TopRightValues = styled.div`
  background: #fff;
`

const TopRightInner = styled.div`
  padding: 0 ${RIGHT_PADDING_X}px;

  @media (max-width: 992px) {
    padding: 0;
  }
`

const ValuesGrid = styled.div`
  display: grid;
  grid-template-columns: ${RIGHT_COLS};
  gap: ${RIGHT_GAP};
  align-items: center;
  justify-items: start;

  @media (max-width: 992px) {
    grid-template-columns: 1fr;
    gap: 10px;
  }
`

const ValueCell = styled.div`
  min-width: 0;

  .valueControl {
    flex: 1;
    display: flex;
    justify-content: flex-end;
    min-width: 180px;
  }

  @media (max-width: 992px) {
    .valueControl {
      min-width: 160px;
    }
  }

  @media (min-width: 993px) {
    .valueControl {
      min-width: unset;
    }
  }

  input {
    max-width: 110px;
  }
`

const DividerLine = styled.div`
  height: 1px;
  background: ${colors.gray3};
  margin: 0 16px;
`

const ContentArea = styled.div`
  padding: 10px 16px 16px 16px;
`

const SizeCell = styled(ValueCell)`
  > * {
    margin-left: 0 !important;
  }

  .react-select__control {
    margin-left: 0 !important;
  }
`
const ActionCell = styled(ValueCell)`
  display: flex;
  align-items: center;
  justify-content: flex-start;

  > * {
    width: 100%;
    min-width: 150px;
  }

  @media (max-width: 992px) {
    > * {
      min-width: unset;
    }
  }
`
const MobileLabel = styled.div`
  display: none;
  font-weight: 700;
  font-size: 0.9rem;

  @media (max-width: 992px) {
    display: block;
  }
`

const MobileRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;

  @media (max-width: 992px) {
    width: 100%;
  }
`

class PositionItem extends Component {
  validationError = null
  quantityExpected = null
  quantityCounted = null
  serialkey = null
  batchkey = null
  rfid = null
  oldValue = null
  enforceUpdate = false
  constructor(props) {
    super(props)

    makeObservable(this, {
      validationError: observable,
      quantityExpected: observable,
      quantityCounted: observable,
      serialkey: observable,
      batchkey: observable,
      rfid: observable,
      oldValue: observable,
      enforceUpdate: observable,
      init: action,
      setPropValue: action,
    })

    this.init()
  }
  componentDidUpdate(prevProps, prevState, snapshot) {
    const { position } = this.props
    if (
      !!this.enforceUpdate || position.enforceUpdate ||
      (!!prevProps && this.positionHasChanged(prevProps.position, position))
    ) {
      this.init()
    }
  }
  init = () => {
    const { position, handleChangePositionByKey } = this.props
    this.quantityExpected = position.quantityExpected
    this.quantityCounted = position.quantityCounted
    this.serialkey = position.serialkey
    this.batchkey = position.batchkey
    this.rfid = position.rfid
    this.enforceUpdate = false
    handleChangePositionByKey(position.id, 'enforceUpdate', false)
  }
  positionHasChanged = (oldPosition, newPosition) => {
    const oldPositionsString = JSON.stringify(oldPosition)
    const newPositionsString = JSON.stringify(newPosition)
    return oldPositionsString !== newPositionsString
  }
  getValidationInfo = () => {
    const { position } = this.props
    const { validation } = position
    let msg = null
    let errorDetails = []

    if (validation) {
      validation.forEach((error) => {
        switch (error.source) {
          case '/serialkey':
            if (!position.serialkey) errorDetails.push(error.detail)
            break
          case '/batchkey':
            if (!position.batchkey) errorDetails.push(error.detail)
            break
          case '/rfid':
            if (!position.rfid) errorDetails.push(error.detail)
            break
          default:
            break
        }
      })
    }
    if (errorDetails.length) {
      msg = errorDetails.join('\n\n')
    }
    return msg
  }
  fieldIsDisabled = (name) => {
    const { position } = this.props
    let disabled = false
    switch (name) {
      case 'serialkey':
      case 'batchkey':
      case 'rfid':
      case 'articleVariant':
      case 'article':
      case 'quantityExpected':
      case 'quantityCounted':
      case 'actionToPerform':
        disabled = getMetaProperty(
          position.metaProperties,
          `/${name}`,
          'isReadOnly'
        )
        break
      default:
        break
    }
    return !!disabled
  }
  onClickRemove = async (e) => {
    const { position, handleDeletePosition } = this.props
    e.preventDefault()
    handleDeletePosition(position.id)
  }
  onClickCopy = async (e) => {
    const { position, handleCopyPosition } = this.props
    e.preventDefault()
    handleCopyPosition(position.id)
  }
  handleOnChangeVariant = async (variant) => {
    this.changePositionByKey('articleVariant', variant.id)
  }
  handleOnChangeActionToPerform = async (value) => {
    this.changePositionByKey('actionToPerform', value)
  }
  handleOnChangeDate = (name) => (date) => {
    this.setPropValue(name, date)
    let value = (date && getIsoDate(date)) || ''
    this.changePositionByKey(name, value)
  }
  handleOnFocus = async (e) => {
    const { value, name } = e.target
    //console.log("handleOnFocus", value, e, id)
    e.preventDefault()
    switch (name) {
      case 'quantityExpected':
      case 'quantityCounted':
        this.updateQuantityChanges('oldValue', value)
        break
      case 'serialkey':
      case 'batchkey':
      case 'rfid':
        break
      default:
        break
    }
  }
  handleOnBlur = async (e) => {
    const { value, name } = e.target
    //console.log("handleOnBlur", value, e, id)
    switch (name) {
      case 'quantityExpected':
      case 'quantityCounted':
        this.updateQuantityChanges(name, value, this.oldValue, true)
        break
      case 'serialkey':
      case 'batchkey':
      case 'rfid':
        this.updateKeyChanges(name, value)
        break
      default:
        break
    }
  }
  handleOnChange = async (e) => {
    const { value, name } = e.target
    //console.log("handleOnChange", value, e, id)
    switch (name) {
      case 'quantityExpected':
      case 'quantityCounted':
        this.updateQuantityChanges(name, value)
        break
      case 'serialkey':
      case 'batchkey':
      case 'rfid':
        this.setPropValue(name, value)
        break
      default:
        break
    }
  }
  handleOnKeyDown = async (e) => {
    if (e.key === 'Enter') {
      const { value, name, id } = e.target
      e.preventDefault() //ENTER key on keyboard and page refreshes
      const { handleNextFocus } = this.props
      switch (name) {
        case 'quantityExpected':
        case 'quantityCounted':
          await this.updateQuantityChanges(name, value, this.oldValue, true)
          handleNextFocus(id, name)
          break
        case 'serialkey':
        case 'batchkey':
        case 'rfid':
          await this.updateKeyChanges(name, value)
          handleNextFocus(id, name)
          break
        default:
          break
      }
    }
  }
  setPropValue = (name, value) => {
    this[name] = value
  }
  updateQuantityChanges = async (
    name,
    value,
    defVal = '',
    updatePosition = false
  ) => {
    const { position } = this.props
    let isValid = false
    let validValue = defVal
    if (isNumeric(value)) {
      validValue = parseInt(value)
      isValid = validValue >= 0
    }
    if (!isValid) {
      validValue = defVal
    }
    switch (name) {
      case 'quantityExpected':
      case 'quantityCounted':
      default:
        this.setPropValue(name, validValue)
        break
    }
    if (!!updatePosition) {
      this.changePositionByKey(name, value)
      if (
        !!position.article.useSerialKeys &&
        !!position.serialkey &&
        this.quantityExpected > 1
      ) {
        //this.splitPosition()
        this.changePositionByKey('serialkey', '')
        this.setPropValue('enforceUpdate', true)
      } else if (
        !!position.article.useRFIDs &&
        !!position.rfid &&
        this.quantityExpected > 1
      ) {
        //this.splitPosition()
        this.changePositionByKey('rfid', '')
        this.setPropValue('enforceUpdate', true)
      }
    }
    //console.log("updateQuantityChanges", value, isNumeric(value), this[name], name, validValue)
  }
  updateKeyChanges = async (name, value) => {
    await this.changePositionByKey(name, value)
    switch (name) {
      case 'serialkey':
        if (!!value && this.quantityExpected > 1) {
          this.splitPosition()
        }
        break
      case 'rfid':
        if (!!value && this.quantityExpected > 1) {
          this.splitPosition()
        }
        break
      default:
        break
    }
  }
  changePositionByKey = async (name, value) => {
    const { position, index, handleChangePositionByKey, resetErrorByFormKey } =
      this.props
    handleChangePositionByKey(position.id, name, value)
    resetErrorByFormKey(`positions${index}${name}`)
  }
  splitPosition = async (splitQuantity = 1) => {
    const { position, handleSplitPosition } = this.props
    handleSplitPosition(position.id, splitQuantity)
    this.setPropValue('enforceUpdate', true)
  }
  getInputId(name) {
    const { position, index } = this.props
    switch (name) {
      case 'quantityExpected':
        return `${position.id}-qe_${index}`
      case 'quantityCounted':
        return `${position.id}-qc_${index}`
      case 'serialkey':
        return `${position.id}-sk_${index}`
      case 'batchkey':
        return `${position.id}-bk_${index}`
      case 'rfid':
        return `${position.id}-rfid_${index}`
      case 'articleVariant':
        return `${position.id}-av_${index}`
      default:
        return `${position.id}-${index}`
    }
  }
  getFormError(name) {
    const { formErrors, index } = this.props
    return formErrors[`positions${index}${name}`]
  }
  renderVariantView() {
    const { position } = this.props
    const { article, articleVariant } = position
    const name = 'articleVariant'
    return (
      <VariantView
        id={this.getInputId(name)}
        articleId={article.id}
        selectedVariant={articleVariant}
        disabled={this.fieldIsDisabled(name)}
        handleOnChange={this.handleOnChangeVariant}
        formError={this.getFormError(name)}
      />
    )
  }
  renderSerialkeyView() {
    const name = 'serialkey'
    return (
      <SerialkeyView
        id={this.getInputId(name)}
        serialkey={this.serialkey}
        disabled={this.fieldIsDisabled(name)}
        handleOnChange={this.handleOnChange}
        handleOnBlur={this.handleOnBlur}
        handleOnKeyDown={this.handleOnKeyDown}
        formError={this.getFormError(name)}
      />
    )
  }
  renderBatchkeyView() {
    const name = 'batchkey'
    return (
      <BatchkeyView
        id={this.getInputId(name)}
        batchkey={this.batchkey}
        disabled={this.fieldIsDisabled(name)}
        handleOnChange={this.handleOnChange}
        handleOnBlur={this.handleOnBlur}
        handleOnKeyDown={this.handleOnKeyDown}
        formError={this.getFormError(name)}
      />
    )
  }
  renderRFIDView() {
    const name = 'rfid'
    const formError = this.getFormError(name)
    return (
      <RFIDView
        id={this.getInputId(name)}
        rfid={this.rfid}
        disabled={this.fieldIsDisabled(name) && !formError}
        handleOnChange={this.handleOnChange}
        handleOnBlur={this.handleOnBlur}
        handleOnKeyDown={this.handleOnKeyDown}
        formError={formError}
      />
    )
  }
  renderQuantityExpected() {
    const { position } = this.props
    const name = 'quantityExpected'
    const formError = this.getFormError(name)
    const disabled = this.fieldIsDisabled(name)
    return (
      <>
        {!disabled ? (
          <>
            <Form.Control
              id={this.getInputId(name)}
              name={name}
              type='number'
              value={this.quantityExpected}
              onChange={this.handleOnChange}
              onFocus={this.handleOnFocus}
              onBlur={this.handleOnBlur}
              onKeyDown={this.handleOnKeyDown}
              min={0}
              max={position.useSerialKeys || position.useRFIDs ? 1 : null}
              isInvalid={!!formError}
              disabled={!!disabled}
            />
            <Form.Control.Feedback type='invalid'>
              {formError}
            </Form.Control.Feedback>
          </>
        ) : (
          <StyledDisabled>{this.quantityExpected}</StyledDisabled>
        )}
      </>
    )
  }
  renderQuantityCounted() {
    const { position } = this.props
    const name = 'quantityCounted'
    const formError = this.getFormError(name)
    const disabled = this.fieldIsDisabled(name)
    return (
      <>
        {!disabled ? (
          <>
            <Form.Control
              id={this.getInputId(name)}
              name={name}
              type='number'
              value={this.quantityCounted}
              onChange={this.handleOnChange}
              onFocus={this.handleOnFocus}
              onBlur={this.handleOnBlur}
              onKeyDown={this.handleOnKeyDown}
              min={0}
              max={position.useSerialKeys || position.useRFIDs ? 1 : this.quantityExpected}
              isInvalid={!!formError}
              disabled={!!disabled}
            />
            <Form.Control.Feedback type='invalid'>
              {formError}
            </Form.Control.Feedback>
          </>
        ) : (
          <StyledDisabled>{this.quantityCounted}</StyledDisabled>
        )}
      </>
    )
  }
  renderActionButtons() {
    const { t, deletable, isStoring } = this.props
    return (
      <>
        {!!deletable && (
          <Row>
            <StyledRemoveLink
              to={'#'}
              onClick={this.onClickRemove}
              tabIndex={-1}
            >
              {t('deleteButton')}
            </StyledRemoveLink>
          </Row>
        )}
        {!isStoring && (
          <Row>
            <StyledCopyLink to={'#'} onClick={this.onClickCopy} tabIndex={-1}>
              {t('officeAdmin:copy')}
            </StyledCopyLink>
          </Row>
        )}
      </>
    )
  }
  renderHeader(title) {
    return <div className='fw-bold'>{title}</div>
  }
  renderActionIcon() {
    const { t, position } = this.props
    return (
      <>
        {position.actionToPerform === 'store' && (
          <StoredIcon title={t('complaints:stored')} isActive={true} />
        )}
        {position.actionToPerform === 'dispose' && (
          <RemovedIcon title={t('complaints:removed')} isActive={true} />
        )}
        {position.actionToPerform === 'markLost' && (
          <LostIcon title={t('complaints:lost')} isActive={true} />
        )}
      </>
    )
  }
  renderActionToPerform() {
    const { t, position, index, formErrors } = this.props
    const disabled = this.fieldIsDisabled('actionToPerform')
    const formError = formErrors[`positions${index}actionToPerform`]
    const options = [
      {
        value: 'nONE',
        name: t('pleaseSelect'),
      },
      {
        value: 'store',
        name: t('returnsProcessingPage:storeAction'),
        icon: <StoredIcon isActive={true} />,
      },
      {
        value: 'dispose',
        name: t('returnsProcessingPage:disposeAction'),
        icon: <RemovedIcon isActive={true} />,
      },
      {
        value: 'markLost',
        name: t('returnsProcessingPage:markLostAction'),
        icon: <LostIcon isActive={true} />,
      },
    ]
    return (
      <>
        {!disabled ? (
          <>
            <CustomDropdownWithIcon
              value={position.actionToPerform}
              data={options}
              returnObject={(e) => this.handleOnChangeActionToPerform(e.value)}
            />
            {!!formError && (
              <StyledValidationMessage>{formError}</StyledValidationMessage>
            )}
          </>
        ) : (
          this.renderActionIcon()
        )}
      </>
    )
  }
  renderTabs() {
    const { position, handleChangePositionByKey, formErrors, index } =
      this.props
    return (
      <PositionTabs
        position={position}
        handleChangePositionByKey={handleChangePositionByKey}
        formErrors={formErrors}
        index={index}
      />
    )
  }
  renderListItem() {
    const { t, position, isStoring } = this.props
    const { article } = position
    const validationInfo = this.getValidationInfo()

    return (
      <React.Fragment>
        <PositionCard>
          <PositionHeaderStrip>
            <HeaderLeftTitle>
              {t('productDetail:articleDescription')}
            </HeaderLeftTitle>{' '}
            <HeaderRightLabels>
              <HeaderLabel>{t('size')}</HeaderLabel>
              <HeaderLabel>
                {t('goodsReceiptPage:quantityExpected')}
              </HeaderLabel>
              <HeaderLabel>{t('goodsReceiptPage:quantityCounted')}</HeaderLabel>
              <HeaderLabel>
                {t('returnsProcessingPage:actionToPerform')}
              </HeaderLabel>
            </HeaderRightLabels>
          </PositionHeaderStrip>

          <PositionTopRow>
            <TopLeft>
              <ArticleName>{article.displayName}</ArticleName>

              <ArticleNr>
                Artikel-Nr: {!!position.isNewPosition && '* '}
                {article.articleNumber}
              </ArticleNr>
            </TopLeft>

            <TopRightValues>
              <TopRightInner>
                <ValuesGrid>
                  <SizeCell>
                    <MobileRow>
                      <MobileLabel>{t('size')}</MobileLabel>
                      <div className='valueControl'>
                        {!!article.isWithSizes && this.renderVariantView()}
                        {!article.isWithSizes && <div>---</div>}
                      </div>
                    </MobileRow>
                  </SizeCell>

                  <ValueCell>
                    <MobileRow>
                      <MobileLabel>
                        {t('goodsReceiptPage:quantityExpected')}
                      </MobileLabel>
                      <div className='valueControl'>
                        {!!isStoring && (
                          <div className='fw-bold'>{this.quantityExpected}</div>
                        )}
                        {!isStoring && this.renderQuantityExpected()}
                      </div>
                    </MobileRow>
                  </ValueCell>

                  <ValueCell>
                    <MobileRow>
                      <MobileLabel>
                        {t('goodsReceiptPage:quantityCounted')}
                      </MobileLabel>
                      <div className='valueControl'>
                        {!!isStoring && this.renderQuantityCounted()}
                        {!isStoring && (
                          <StyledDisabled>
                            {this.quantityCounted}
                          </StyledDisabled>
                        )}
                      </div>
                    </MobileRow>
                  </ValueCell>

                  <ActionCell>
                    <MobileRow>
                      <MobileLabel>
                        {t('returnsProcessingPage:actionToPerform')}
                      </MobileLabel>
                      <div className='valueControl'>
                        {this.renderActionToPerform()}
                      </div>
                    </MobileRow>
                  </ActionCell>
                </ValuesGrid>
              </TopRightInner>
            </TopRightValues>
          </PositionTopRow>

          <DividerLine />

          <ContentArea>
            {(!!article.useSerialKeys || !!article.useBatchKeys || !!article.useRFIDs) && (
              <Row>
                {!!article.useSerialKeys && (
                  <Col>{this.renderSerialkeyView()}</Col>
                )}
                {!!article.useRFIDs && (
                  <Col>{this.renderRFIDView()}</Col>
                )}
                {!!article.useBatchKeys && (
                  <Col>{this.renderBatchkeyView()}</Col>
                )}
              </Row>
            )}

            {this.renderTabs()}

            {this.validationError && (
              <Alert variant='danger' className='mb-3'>
                {this.validationError}
              </Alert>
            )}

            {validationInfo && (
              <Alert variant='info' className='mb-3'>
                {validationInfo}
              </Alert>
            )}
          </ContentArea>
        </PositionCard>
      </React.Fragment>
    )
  }

  render() {
    return <>{this.renderListItem()}</>
  }
}

export default withTranslation()(observer(PositionItem))
